import React, {useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import DialogMessage from './DialogMessage';

export default function GlobalDialogMessage() {
    const [isOpen, setOpen] = useState(false);
    const message = useSelector(state => state.message, shallowEqual);

    useEffect(() => {
        message.id && setOpen(true);
    }, [message.id]);

    const onClose = () => setOpen(false);

    return (
        <DialogMessage
            open={isOpen}
            onClose={onClose}
            type={message.type}
            message={message.text} />
    );
}